const pixelsCategories = ["PERFORMANCE","TARGETING"];

export { pixelsCategories };